import {
  Icon,
  SidebarGroup,
  SidebarMenu,
  SidebarMenuBadge,
  SidebarMenuButton,
  SidebarMenuItem,
  Text,
} from "@salestrak/ui";

import { useSidebarNav } from "../use-sidebar-nav";
import { useInboxUnreadCount } from "#app/hooks/inbox/use-inbox-unread-count";

/** Home's primary destinations: Inbox (live unread badge) + My Work. */
export function HomeNavSection() {
  const { navigate, isActive } = useSidebarNav();
  const inboxUnreadCount = useInboxUnreadCount();

  return (
    <SidebarGroup>
      <SidebarMenu>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={isActive("/inbox")}
            onClick={() => navigate("/inbox")}
          >
            <Icon name="inbox" />
            <Text truncate>Inbox</Text>
          </SidebarMenuButton>
          {/* The unread count is the sidebar's own badge slot — positioned
            * against the row, outside the button, so it never competes with
            * the label for truncation. */}
          {inboxUnreadCount > 0 && (
            <SidebarMenuBadge>{inboxUnreadCount}</SidebarMenuBadge>
          )}
        </SidebarMenuItem>
        <SidebarMenuItem>
          <SidebarMenuButton
            isActive={isActive("/my-work")}
            onClick={() => navigate("/my-work")}
          >
            <Icon name="user-check" />
            <Text truncate>My Work</Text>
          </SidebarMenuButton>
        </SidebarMenuItem>
      </SidebarMenu>
    </SidebarGroup>
  );
}
